// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3a-XD","colMaxWidth":"Table_colMaxWidth__1hb_j"};